import { Injectable } from '@angular/core';
import {
  HttpContext,
  HttpHeaders,
  HttpClient,
  HttpParams,
} from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { SKIP_GLOBAL_LOADER } from '../interceptors/loader-context';

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) {}

  private jsonHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  private formatErrors(error: any) {
    return throwError(() => error?.error ?? error);
  }

  private extractResponseData(response: any) {
    if (response && typeof response.success !== 'undefined') {
      if (response.success === 0) {
        return response.data;
      }
      throw response;
    }

    return response;
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .get(`${environment.serverUrl}${path}`, {
        headers: this.jsonHeaders(),
        params,
      })
      .pipe(catchError(this.formatErrors));
  }

  getWithoutGlobalLoader(
    path: string,
    params: HttpParams = new HttpParams()
  ): Observable<any> {
    return this.http
      .get(`${environment.serverUrl}${path}`, {
        context: new HttpContext().set(SKIP_GLOBAL_LOADER, true),
        headers: this.jsonHeaders(),
        params,
      })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http
      .put(`${environment.serverUrl}${path}`, JSON.stringify(body), {
        headers: this.jsonHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  putParams(path: string, params: HttpParams): Observable<any> {
    let postbody = {};
    return this.http
      .put(`${environment.serverUrl}${path}`, postbody, {
        headers: this.jsonHeaders(),
        params,
      })
      .pipe(catchError(this.formatErrors));
  }

  putFile(path: string, data: FormData): Observable<any> {
    return this.http
      .put(`${environment.serverUrl}${path}`, data)
      .pipe(catchError(this.formatErrors));
  }

  postFile(path: string, data: FormData): Observable<any> {
    // let headers = new HttpHeaders({ 'Content-Type': 'multipart/form-data '  });
    return this.http
      .post(`${environment.serverUrl}${path}`, data)
      .pipe(catchError(this.formatErrors));
  }

  post(path: string, body: any): Observable<any> {
    return this.http
      .post(`${environment.serverUrl}${path}`, JSON.stringify(body), {
        headers: this.jsonHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  postWithCredentials(path: string, body: any): Observable<any> {
    return this.http
      .post(`${environment.serverUrl}${path}`, JSON.stringify(body), {
        headers: this.jsonHeaders(),
        withCredentials: true,
      })
      .pipe(catchError(this.formatErrors));
  }

  postWithoutGlobalLoader(path: string, body: any): Observable<any> {
    return this.http
      .post(`${environment.serverUrl}${path}`, JSON.stringify(body), {
        context: new HttpContext().set(SKIP_GLOBAL_LOADER, true),
        headers: this.jsonHeaders(),
      })
      .pipe(catchError(this.formatErrors));
  }

  checkContent(body: any, _contentType?: any): Observable<any> {
    const formData = new FormData();
    formData.append('mediaFile', body, body?.name || 'upload');

    return this.http
      .post(
        `${environment.serverUrl}rest/reviews/contentSafety/image`,
        formData
      )
      .pipe(
        map((response: any) => this.extractResponseData(response)),
        catchError(this.formatErrors)
      );
  }

  postParams(path: string, params: HttpParams): Observable<any> {
    let postbody = {};
    return this.http
      .post(`${environment.serverUrl}${path}`, postbody, {
        headers: this.jsonHeaders(),
        params,
      })
      .pipe(catchError(this.formatErrors));
  }

  delete(path: string, params: HttpParams): Observable<any> {
    return this.http
      .delete(`${environment.serverUrl}${path}`, {
        headers: this.jsonHeaders(),
        params,
      })
      .pipe(catchError(this.formatErrors));
  }

  checkTextContent(body: string | string[]): Observable<any> {
    const payload = Array.isArray(body)
      ? { texts: body.filter((s) => s && s.trim().length > 0) }
      : { text: body };

    return this.http
      .post(`${environment.serverUrl}rest/reviews/contentSafety/text`, payload)
      .pipe(
        map((response: any) => this.extractResponseData(response)),
        catchError(this.formatErrors)
      );
  }
}
